import Image from 'next/image';
import { Text } from '@BICE_Vida/components';
import classNames from 'classnames';
import { CYBER_IMAGES } from '@/utils/assets';
import styles from './CyberReview.module.scss';

type LeadManagerEstimateReviewCyberT = {
  discount: JSX.Element | string;
  className?: string;
};

const LeadManagerEstimateReviewCyber = ({
  discount,
  className,
}: LeadManagerEstimateReviewCyberT) => {
  const reviewCyberClasses = classNames(styles.cyber_review, {
    [`${className}`]: className,
  });

  return (
    <div className={reviewCyberClasses}>
      <Image src={CYBER_IMAGES.REVIEW} height={32} width={32} alt="cyber-icon" />
      <div>
        <Text className={styles.cyber_review_text}>{discount}</Text>
      </div>
    </div>
  );
};

export default LeadManagerEstimateReviewCyber;
